var $820877bea407f5fe$exports = {};
const $820877bea407f5fe$var$asLowerCase = (a)=>a.toLowerCase();
const $820877bea407f5fe$var$isActive = (d)=>$820877bea407f5fe$var$asLowerCase(d?.status) === "active";
const $820877bea407f5fe$var$asArray = (v)=>Array.from(v);
// eslint-disable-next-line import/prefer-default-export
const $820877bea407f5fe$var$filterActive = (d)=>d.reduce((a, c)=>$820877bea407f5fe$var$isActive(c) ? [
            ...a,
            c
        ] : a, []);
const $820877bea407f5fe$var$firstUpperCase = (s)=>s.toLowerCase().replace(/\b[a-z](?=[a-z]{2})/g, (letter)=>letter.toUpperCase());
const $820877bea407f5fe$var$capitaliseFirstLetter = (arr)=>arr.map((v)=>$820877bea407f5fe$var$firstUpperCase(v));
const $820877bea407f5fe$var$isContainerViewPort = (c)=>c.classList.contains("map-viewport-container");
const $820877bea407f5fe$var$sliceTags = (t)=>t.slice(0, 2).join(", ");
const $820877bea407f5fe$var$addContent = (t)=>`... +${t.length - 2} more`;
const $820877bea407f5fe$var$maybeAddContent = (t)=>t.length === 2 ? [
        $820877bea407f5fe$var$sliceTags(t)
    ] : [
        `${$820877bea407f5fe$var$sliceTags(t)} ${$820877bea407f5fe$var$addContent(t)}`
    ];
const $820877bea407f5fe$var$maybeSliceTags = (t, c)=>t.length >= 2 && $820877bea407f5fe$var$isContainerViewPort(c) ? $820877bea407f5fe$var$maybeAddContent(t) : t;
const $820877bea407f5fe$var$addPill = (el)=>el.classList.add("tag-pill");
const $820877bea407f5fe$var$maybeAddPill = (el, c)=>!$820877bea407f5fe$var$isContainerViewPort(c) ? $820877bea407f5fe$var$addPill(el) : el;
const $820877bea407f5fe$var$setContent = (el, c)=>el.textContent = c;
const $820877bea407f5fe$var$appendTags = (mapItemProp, tag, container)=>{
    const tagElement = document.createElement("div");
    $820877bea407f5fe$var$setContent(tagElement, tag);
    $820877bea407f5fe$var$maybeAddPill(tagElement, container);
    return mapItemProp.appendChild(tagElement);
};
const $820877bea407f5fe$var$setTags = (container)=>(v)=>{
        const tags = v.textContent.split(",").map((tag)=>tag.trim());
        $820877bea407f5fe$var$setContent(v);
        $820877bea407f5fe$var$maybeSliceTags(tags, container).map((tag)=>$820877bea407f5fe$var$appendTags(v, tag, container));
    };
const $820877bea407f5fe$var$selectTags = (v)=>v.querySelectorAll('map-item-prop[name="tags"]');
const $820877bea407f5fe$var$isAddedNodeMapItem = (node)=>// eslint-disable-next-line no-undef
    node instanceof Element && node.nodeName.toLowerCase() === "map-item";
const $820877bea407f5fe$var$visualiseTags = (container)=>{
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            const addedNodes = Array.from(mutation.addedNodes);
            const mapItemProps = addedNodes.filter($820877bea407f5fe$var$isAddedNodeMapItem).flatMap((mapItem)=>$820877bea407f5fe$var$asArray($820877bea407f5fe$var$selectTags(mapItem)));
            mapItemProps.forEach($820877bea407f5fe$var$setTags(container));
        });
    });
    return observer.observe(container, {
        childList: true,
        subtree: true
    });
};
$820877bea407f5fe$exports = {
    filterActive: $820877bea407f5fe$var$filterActive,
    capitaliseFirstLetter: $820877bea407f5fe$var$capitaliseFirstLetter,
    visualiseTags: $820877bea407f5fe$var$visualiseTags
};


var $9c2a3a82ed21c8f4$require$filterActive = $820877bea407f5fe$exports.filterActive;
const $9c2a3a82ed21c8f4$var$viewport = document.querySelector("map-viewport");
$9c2a3a82ed21c8f4$var$viewport.init("google", "AIzaSyAbvtFai2_G3xh6p1NCFpOfxdqUstrXQzc");
const $9c2a3a82ed21c8f4$var$fromLatLon = ({ lat: lat , lon: lon  })=>({
        lat: lat,
        lng: lon
    });
const $9c2a3a82ed21c8f4$var$transformSeniors = (d)=>d.map(({ location: location , name: name , category: category , ...rest })=>({
            ...$9c2a3a82ed21c8f4$var$fromLatLon(location),
            name: name.trim(),
            tags: [
                category
            ],
            ...rest
        }));
const $9c2a3a82ed21c8f4$var$toggleContent = (d)=>(document.querySelector("div.loading").style.display = "none", document.querySelector("div.content").style.display = "block", d);
const $9c2a3a82ed21c8f4$var$URL = "https://api.maps-stg.testservicensw.net";
const $9c2a3a82ed21c8f4$var$getData = ()=>fetch(`${$9c2a3a82ed21c8f4$var$URL}/cache/seniorscard`).then((res)=>res.json()).then($9c2a3a82ed21c8f4$require$filterActive).then((d)=>$9c2a3a82ed21c8f4$var$viewport.load($9c2a3a82ed21c8f4$var$transformSeniors(d))).then($9c2a3a82ed21c8f4$var$toggleContent);
$9c2a3a82ed21c8f4$var$viewport.init("google", "AIzaSyAbvtFai2_G3xh6p1NCFpOfxdqUstrXQzc").then($9c2a3a82ed21c8f4$var$getData);
let $9c2a3a82ed21c8f4$var$footerExpanded = false;
const $9c2a3a82ed21c8f4$var$footerButton = document.getElementById("FooterButton");
const $9c2a3a82ed21c8f4$var$list = document.querySelector(".map-list-container");
const $9c2a3a82ed21c8f4$var$footer = document.getElementById("FooterContainer");
const $9c2a3a82ed21c8f4$var$viewportContainer = document.querySelector(".map-viewport-container");
const $9c2a3a82ed21c8f4$var$recordCount = document.querySelector(".record-counts");
$9c2a3a82ed21c8f4$var$footerButton.addEventListener("click", ()=>{
    $9c2a3a82ed21c8f4$var$footerExpanded = !$9c2a3a82ed21c8f4$var$footerExpanded;
    $9c2a3a82ed21c8f4$var$footer.style.bottom = $9c2a3a82ed21c8f4$var$footerExpanded ? 0 : "";
    $9c2a3a82ed21c8f4$var$footer.style.overflow = $9c2a3a82ed21c8f4$var$footerExpanded ? "scroll" : "hidden";
});
$9c2a3a82ed21c8f4$var$list.addEventListener("click", ()=>{
    setTimeout(()=>{
        const closeButton = document.querySelector('map-selection button[close-button="true"]');
        const mapSelection = document.querySelector("map-selection");
        $9c2a3a82ed21c8f4$var$list.classList.add("mobile-hidden-by-selection");
        $9c2a3a82ed21c8f4$var$recordCount.classList.add("mobile-hidden-by-selection");
        mapSelection.scrollTop = 0;
        closeButton.addEventListener("click", ()=>{
            $9c2a3a82ed21c8f4$var$list.classList.remove("mobile-hidden-by-selection");
            $9c2a3a82ed21c8f4$var$recordCount.classList.remove("mobile-hidden-by-selection");
        });
    });
});
const $9c2a3a82ed21c8f4$var$selection = document.querySelector("map-selection");
// Click phone number link
$9c2a3a82ed21c8f4$var$selection.addEventListener("click-phone", ({ detail: detail  })=>window.open(`tel:${detail.phone}`, "_self"));
// Click webiste link
$9c2a3a82ed21c8f4$var$selection.addEventListener("click-link", ({ detail: detail  })=>{
    window.open(detail.web, "_blank");
});
// Click get directions
$9c2a3a82ed21c8f4$var$selection.addEventListener("click-directions", ({ detail: detail  })=>{
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${detail.address}&travelmode=driving`);
});
const $9c2a3a82ed21c8f4$var$reportBusinessUrl = "https://customervoice.microsoft.com/Pages/ResponsePage.aspx?id=aHr5Hqvo7UShbbV5_i182N5cdQRFA79Dr5WwJugBHeFUMTFCMUtVNlA2RFkwSDJCRktMVjJIMUg1NS4u";
const $9c2a3a82ed21c8f4$var$encode = (v)=>encodeURIComponent(v);
const $9c2a3a82ed21c8f4$var$asQuery = (v)=>`&ctx={ bid: "${v.id}", bname: "${$9c2a3a82ed21c8f4$var$encode(v.name)}", baddress: "${$9c2a3a82ed21c8f4$var$encode(v.address)}", locale: "en", dataindex: "seniors"  }`;
// Report business button
$9c2a3a82ed21c8f4$var$selection.addEventListener("click-report-business", ({ detail: detail  })=>{
    window.open(`${$9c2a3a82ed21c8f4$var$reportBusinessUrl}${$9c2a3a82ed21c8f4$var$asQuery(detail)}`, "_blank");
});
const $9c2a3a82ed21c8f4$var$toggleButton = (btn)=>btn.style.display === "flex" ? btn.style.display = "none" : btn.style.display = "flex";
// Share business button
// Add <a> tags href with links to social media
const $9c2a3a82ed21c8f4$var$shareBusiness = (url)=>{
    document.querySelectorAll(".share-business-dropdown a").forEach((a, i)=>{
        a.target = "_blank";
        switch(i){
            case 0:
                a.href = `https://www.facebook.com/sharer.php?u=${url}`;
                break;
            case 1:
                a.href = `https://twitter.com/intent/tweet?text=${url}`;
                break;
            case 2:
                a.href = `https://www.linkedin.com/sharing/share-offsite/?mini=true&url=${url}`;
                break;
            case 3:
                a.href = `https://api.whatsapp.com/send/?text=${url}`;
                break;
            case 4:
                a.href = `mailto:?subject=Check out this business&body=${url}`;
                break;
            default:
                break;
        }
    });
};
$9c2a3a82ed21c8f4$var$selection.addEventListener("click-share-business", ()=>{
    const shareButton = document.querySelector(".share-business-dropdown");
    $9c2a3a82ed21c8f4$var$toggleButton(shareButton);
    $9c2a3a82ed21c8f4$var$shareBusiness(window.location.href);
});
const $9c2a3a82ed21c8f4$var$mapViewButton = document.getElementById("map-view-tab-button");
const $9c2a3a82ed21c8f4$var$listViewButton = document.getElementById("list-view-tab-button");
// Switch to map view
$9c2a3a82ed21c8f4$var$mapViewButton.addEventListener("click", ()=>{
    $9c2a3a82ed21c8f4$var$viewportContainer.classList.remove("mobile-hidden-by-view");
    $9c2a3a82ed21c8f4$var$list.classList.add("mobile-hidden-by-view");
    $9c2a3a82ed21c8f4$var$mapViewButton.style.borderBottom = "2px solid red";
    $9c2a3a82ed21c8f4$var$listViewButton.style.borderBottom = "medium none";
});
// Switch to list view
$9c2a3a82ed21c8f4$var$listViewButton.addEventListener("click", ()=>{
    $9c2a3a82ed21c8f4$var$viewportContainer.classList.add("mobile-hidden-by-view");
    $9c2a3a82ed21c8f4$var$list.classList.remove("mobile-hidden-by-view");
    $9c2a3a82ed21c8f4$var$mapViewButton.style.borderBottom = "medium none";
    $9c2a3a82ed21c8f4$var$listViewButton.style.borderBottom = "2px solid red";
});


//# sourceMappingURL=index.5e853d5e.js.map
